<template>
  <!-- Modal -->
  <modal :close="close">
    <h3 slot="header">{{ $t('reward.new') }}</h3>
    <div slot="body">
      <div class="modal-body">
        <button v-show="showAddNext" type="button" @click="addNext" :class="'btn btn-tile uppercase ' + buttonColor" style="max-height:200px">{{ $t('reward.addNext') }}</button>
        <div v-show="!showAddNext">
          <form-error :errors='errors' :attribute="'title'">
            <input v-model="form.title" type="text" class="form-control" :placeholder="$t('title')">
          </form-error>
          <div class="form-group">
            <form-error :errors='errors' :attribute="'price'">
              <label class="sr-only" for="reward-price">{{ $t("reward.price") }}</label>
              <div class="input-group">
                  <div class="input-group-addon">{{ $t("reward.price") }}:</div>
                    <input v-model="form.price" type="number" class="form-control">
                  <div class="input-group-addon">{{ currency }}</div>
              </div>
            </form-error>
          </div>
          <form-error :errors='errors' :attribute="'quantity'">
            <input v-model.number="form.quantity" type="number" class="form-control" :placeholder="$t('reward.quantity')">
          </form-error>
          <form-error :errors='errors' :attribute="'description'">
            <textarea v-model="form.description" rows="5" type="text" class="form-control" :placeholder="$t('reward.description')"></textarea>
          </form-error>
          <div v-if="form.photo.url">
            <img class="reward-image" :src="$server_url + form.photo.url" alt=""/>
          </div>
          <div v-else>
            <img class="reward-image" :src="form.photo" alt=""/>
          </div>
          <form-error :errors='errors' :attribute="'photo'">
             <button type="button" @click="$refs.addDocuments.$refs.input.click()" class="btn btn-default btn-lg button-wide-crowd mb-0 uppercase">
                <span v-if="!form.photo.url && !image">{{ $t("profile.edit.addImageButton") }}</span>
                <span v-else>{{ $t("profile.edit.changeImageButton") }}</span>
              </button>
              <upload-base64 :multiple="false" :done="getFile" ref="addDocuments"></upload-base64>
          </form-error>
        </div>
        <div v-show="showAddNext" class="mt-20" style="height:40px">
          <alert :success="alert.success"></alert>
        </div>
        <alert v-show="!showAddNext" :success="alert.success"></alert>
      </div>
    </div>
    <div v-show="!showAddNext" slot="footer" style="display: inline">
      <button @click="submit()" type="button" class="btn btn-primary uppercase">{{ $t("save") }}</button>
    </div>
  </modal>
</template>

<script>
import rewardsApi from '@/api/v1/rewards';

import Modal from '@/components/Modal';
import Alert from '@/components/Alert';
import FormError from '@/components/FormError';
import UploadBase64 from '@/components/UploadBase64';

// Mixins
import alert from '@/mixins/alert';

export default {
  props: {
    close: Function,
    rewards: Array,
    currency: String,
    action: String,
    buttonColor: String,
    reward: {
      default() {
        return {
          title: '',
          photo: {},
        };
      },
    },
  },
  components: { Modal, Alert, FormError, UploadBase64 },
  mixins: [alert],
  data() {
    return {
      showAddNext: false,
      form: this.reward,
      image: '',
    };
  },
  methods: {
    submit() {
      return this.action === 'create' ? this.addReward() : this.editReward();
    },
    addReward() {
      this.clearAlerts();
      rewardsApi.addReward(this.$route.params.id, this.form).then((response) => {
        response.data.price /= 100;
        this.rewards.push(response.data);
        this.alert.success = this.$t('reward.createdAlert');
        setTimeout(() => { this.alert.success = null; }, 3000);
        this.showAddNext = true;
      }).catch((response) => {
        this.errors = response.response.data;
      });
    },
    editReward() {
      this.clearAlerts();
      rewardsApi.editReward(this.$route.params.id, this.form).then(() => {
        this.alert.success = 'Zmiany zostały zapisane';
        setTimeout(() => { this.alert.success = null; }, 3000);
      }).catch((response) => {
        this.errors = response.response.data;
      });
    },
    addNext() {
      this.clearAlerts();
      this.form = { title: '', photo: {} };
      this.showAddNext = false;
    },
    getFile(file) {
      this.form.photo = file.base64;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Form.vue?6883999e